import ApiService from './../services/api.service'

const state = {
    users: [],
    roles: []
}

const mutations = {
    SET_USERS (state, payload) {
        state.users = payload.data.data
    },

    SET_ROLES (state, payload) {
        state.roles = payload.data.data
    }
}

const actions = {
    async loadUsers ({ commit, state }, type) {

        const userTypes = type === 'customer' ? 'customer': 'service'

        await ApiService.get('users/' + userTypes).then((data)=> {
            commit('SET_USERS', data)
        })
    },

    async loadUsersByRole ({ commit, state }, type) {

        await ApiService.get('users/roles/' + type).then((data)=> {
            commit('SET_USERS', data)
        })
    },

    async loadRoles ({ commit, state }, type) {

        await ApiService.get('users/roles').then((data)=> {
            commit('SET_ROLES', data)
        })
    },

    setAktiv ({ commit, state }, data) {
        ApiService.post('users/active/' + data.id, { status: data.event})
    },
}

const getters = {
    getUsers: state => state.users,
    getRoles: state => state.roles,
    countUsers: (state, getters) => {
        return getters.getUsers.length
    },
    getUserById: (state) => (id) => {
        return state.users.find(user => user.id === id)
    }
}

export const user = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
